import { render, staticRenderFns } from "./AttendanceSpecialLeave.vue?vue&type=template&id=15d6743b"
import script from "./AttendanceSpecialLeave.vue?vue&type=script&lang=js"
export * from "./AttendanceSpecialLeave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports